require('dotenv').config();
const axios = require('axios');
import store from '@/store';

// Environment-based API base URL determination
const local = window.location.href.includes('localhost');
const dev = window.location.href.includes('dev.');

const apiBase = local
  ? 'http://localhost:4040'
  : dev
  ? 'https://tiimi-development.herokuapp.com'
  : 'https://api.epesis3.com';

// Axios instance configuration
const ax = axios.create({
  baseURL: apiBase,
  withCredentials: true, // Include cookies with all requests
});

// console.log('API Base:', apiBase);

// Helper function to get the token from localStorage
const getToken = () => localStorage.getItem('tiimio-token');

// Helper function to set the token in localStorage
const setToken = (newToken) => {
  localStorage.setItem('tiimio-token', newToken);
};

// Helper function to handle failed refresh and redirect to login
const handleRefreshFailure = () => {
  localStorage.removeItem('tiimio-token');
  window.location.href = '/#/login'; // Redirect to login
};

// Request interceptor to attach the token to requests
ax.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    (error) => Promise.reject(error)
    return config;
  },
);

// Response interceptor to handle token refresh
let isRefreshing = false; // Flag to track ongoing refresh requests
let refreshSubscribers = []; // Queue for pending requests during token refresh

// Notify all subscribers with the new token
const onTokenRefreshed = (newToken) => {
  store.dispatch('user/initUser', newToken, { root: true });
  refreshSubscribers.forEach((callback) => callback(newToken));
  refreshSubscribers = [];
};

// Add response interceptor
ax.interceptors.response.use(
  (response) => response, // Pass through successful responses
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const currentTeamId = store.getters['user/currentTeamId'];
          const refreshResponse = await ax.post(`/auth/refresh?currentTeamId=${currentTeamId}`);

          const { token: newToken } = refreshResponse.data;

          setToken(newToken); // Update token in localStorage
          onTokenRefreshed(newToken); // Notify pending requests
          isRefreshing = false;

          // Retry the original request with the new token
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          return ax(originalRequest);
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          handleRefreshFailure();
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      }

      // Queue subsequent requests until the refresh workflow completes
      return new Promise((resolve) => {
        refreshSubscribers.push((newToken) => {
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
          resolve(ax(originalRequest));
        });
      });
    }

    // Reject other errors
    return Promise.reject(error);
  }
);

export default ax;
